export default "__VITE_ASSET__g4TnZY7K__"